import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { cast, getParent, getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import { Region } from '@jbrowse/core/util/types/mst';
import { transaction } from 'mobx';
import { saveAs } from 'file-saver';
import { renderToSvg } from '../svgcomponents/SVGCircularView';
import { readConfObject } from '@jbrowse/core/configuration';
import { getSession, clamp, isSessionModelWithWidgets } from '@jbrowse/core/util';
import { BaseViewModel } from '@jbrowse/core/pluggableElementTypes/models';
// icons
import { TrackSelector as TrackSelectorIcon } from '@jbrowse/core/ui/Icons';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
// locals
import ExportSvgDlg from '../components/ExportSvgDialog';
import { calculateStaticSlices, sliceIsVisible } from './slices';
import { viewportVisibleSection } from './viewportVisibleRegion';
/**
 * #stateModel CircularView
 * extends `BaseViewModel`
 */
function stateModelFactory(pluginManager) {
  var minHeight = 40;
  var minWidth = 100;
  var defaultHeight = 400;
  return types.compose(BaseViewModel, types.model('CircularView', {
    /**
     * #property
     */
    type: types.literal('CircularView'),
    /**
     * #property
     * similar to offsetPx in linear genome view
     */
    offsetRadians: -Math.PI / 2,
    /**
     * #property
     */
    bpPerPx: 200,
    /**
     * #property
     */
    tracks: types.array(pluginManager.pluggableMstType('track', 'stateModel')),
    /**
     * #property
     */
    hideVerticalResizeHandle: false,
    /**
     * #property
     */
    hideTrackSelectorButton: false,
    /**
     * #property
     */
    lockedFitToWindow: true,
    /**
     * #property
     */
    disableImportForm: false,
    /**
     * #property
     */
    height: types.optional(types.refinement('trackHeight', types.number, function (n) {
      return n >= minHeight;
    }), defaultHeight),
    /**
     * #property
     */
    displayedRegions: types.array(Region),
    /**
     * #property
     */
    scrollX: 0,
    /**
     * #property
     */
    scrollY: 0,
    minimumRadiusPx: 25,
    spacingPx: 10,
    paddingPx: 80,
    lockedPaddingPx: 100,
    minVisibleWidth: 6,
    minimumBlockWidth: 20,
    trackSelectorType: 'hierarchical'
  })).volatile(function () {
    return {
      volatileWidth: undefined,
      error: undefined
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get width() {
        if (self.volatileWidth === undefined) {
          throw new Error('wait for view to be initialized first before accessing width');
        }
        return self.volatileWidth;
      },
      /**
       * #getter
       */
      get visibleSection() {
        return viewportVisibleSection([self.scrollX, self.scrollX + self.width, self.scrollY, self.scrollY + self.height], this.centerXY, this.radiusPx);
      },
      /**
       * #getter
       */
      get circumferencePx() {
        var elidedBp = 0;
        var _iterator = _createForOfIteratorHelper(this.elidedRegions),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var r = _step.value;
            elidedBp += r.widthBp;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return elidedBp / self.bpPerPx + self.spacingPx * this.elidedRegions.length;
      },
      /**
       * #getter
       */
      get radiusPx() {
        return this.circumferencePx / (2 * Math.PI);
      },
      /**
       * #getter
       */
      get bpPerRadian() {
        return self.bpPerPx * this.radiusPx;
      },
      /**
       * #getter
       */
      get pxPerRadian() {
        return this.radiusPx;
      },
      /**
       * #getter
       */
      get centerXY() {
        return [this.radiusPx + self.paddingPx, this.radiusPx + self.paddingPx];
      },
      /**
       * #getter
       */
      get totalBp() {
        var total = 0;
        var _iterator2 = _createForOfIteratorHelper(self.displayedRegions),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var region = _step2.value;
            total += region.end - region.start;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return total;
      },
      /**
       * #getter
       */
      get maximumRadiusPx() {
        return self.lockedFitToWindow ? Math.min(self.width, self.height) / 2 - self.lockedPaddingPx : 1000000;
      },
      /**
       * #getter
       */
      get maxBpPerPx() {
        var minCircumferencePx = 2 * Math.PI * self.minimumRadiusPx;
        return this.totalBp / minCircumferencePx;
      },
      /**
       * #getter
       */
      get minBpPerPx() {
        // min depends on window dimensions, clamp between old min(0.01) and max
        var maxCircumferencePx = 2 * Math.PI * this.maximumRadiusPx;
        return clamp(this.totalBp / maxCircumferencePx, 0.0000000001, this.maxBpPerPx);
      },
      /**
       * #getter
       */
      get atMaxBpPerPx() {
        return self.bpPerPx >= this.maxBpPerPx;
      },
      /**
       * #getter
       */
      get atMinBpPerPx() {
        return self.bpPerPx <= this.minBpPerPx;
      },
      /**
       * #getter
       */
      get tooSmallToLock() {
        return this.minBpPerPx <= 0.0000000001;
      },
      /**
       * #getter
       */
      get figureDimensions() {
        return [this.radiusPx * 2 + 2 * self.paddingPx, this.radiusPx * 2 + 2 * self.paddingPx];
      },
      /**
       * #getter
       */
      get figureWidth() {
        return this.figureDimensions[0];
      },
      /**
       * #getter
       */
      get figureHeight() {
        return this.figureDimensions[1];
      },
      /**
       * #getter
       * this is displayedRegions, post-processed to
       * elide regions that are too small to see reasonably
       */
      get elidedRegions() {
        var visible = [];
        self.displayedRegions.forEach(function (region) {
          var widthBp = region.end - region.start;
          var widthPx = widthBp / self.bpPerPx;
          if (widthPx < self.minVisibleWidth) {
            // too small to see, collapse into a single elision region
            var lastVisible = visible[visible.length - 1];
            if (lastVisible === null || lastVisible === void 0 ? void 0 : lastVisible.elided) {
              lastVisible.regions.push(_objectSpread({}, region));
              lastVisible.widthBp += widthBp;
            } else {
              visible.push({
                elided: true,
                widthBp: widthBp,
                regions: [_objectSpread({}, region)]
              });
            }
          } else {
            // big enough to see, display it
            visible.push(_objectSpread({}, region, {
              widthBp: widthBp,
              elided: false
            }));
          }
        });
        // remove any single-region elisions
        for (var i = 0; i < visible.length; i += 1) {
          var v = visible[i];
          if (v.elided && v.regions.length === 1) {
            visible[i] = _objectSpread({}, v, v.regions[0], {
              elided: false
            });
          }
        }
        return visible;
      },
      /**
       * #getter
       */
      get assemblyNames() {
        var assemblyNames = [];
        self.displayedRegions.forEach(function (displayedRegion) {
          if (!assemblyNames.includes(displayedRegion.assemblyName)) {
            assemblyNames.push(displayedRegion.assemblyName);
          }
        });
        return assemblyNames;
      },
      /**
       * #getter
       */
      get initialized() {
        var _getSession = getSession(self),
          assemblyManager = _getSession.assemblyManager;
        return self.volatileWidth !== undefined && this.assemblyNames.every(function (a) {
          var _a;
          return (_a = assemblyManager.get(a)) === null || _a === void 0 ? void 0 : _a.initialized;
        });
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get staticSlices() {
        return calculateStaticSlices(self);
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get visibleStaticSlices() {
        return self.staticSlices.filter(function (s) {
          return sliceIsVisible(self, s);
        });
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setWidth: function setWidth(newWidth) {
        self.volatileWidth = Math.max(newWidth, minWidth);
        return self.volatileWidth;
      },
      /**
       * #action
       */
      setHeight: function setHeight(newHeight) {
        self.height = Math.max(newHeight, minHeight);
        return self.height;
      },
      /**
       * #action
       */
      resizeHeight: function resizeHeight(distance) {
        var oldHeight = self.height;
        var newHeight = this.setHeight(self.height + distance);
        this.setModelViewWhenAdjust(!self.tooSmallToLock);
        return newHeight - oldHeight;
      },
      /**
       * #action
       */
      resizeWidth: function resizeWidth(distance) {
        var oldWidth = self.width;
        var newWidth = this.setWidth(self.width + distance);
        this.setModelViewWhenAdjust(!self.tooSmallToLock);
        return newWidth - oldWidth;
      },
      /**
       * #action
       */
      rotateClockwiseButton: function rotateClockwiseButton() {
        this.rotateClockwise(Math.PI / 6);
      },
      /**
       * #action
       */
      rotateCounterClockwiseButton: function rotateCounterClockwiseButton() {
        this.rotateCounterClockwise(Math.PI / 6);
      },
      /**
       * #action
       */
      rotateClockwise: function rotateClockwise() {
        var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.17;
        self.offsetRadians += distance;
      },
      /**
       * #action
       */
      rotateCounterClockwise: function rotateCounterClockwise() {
        var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.17;
        self.offsetRadians -= distance;
      },
      /**
       * #action
       */
      zoomInButton: function zoomInButton() {
        this.setBpPerPx(self.bpPerPx / 1.4);
      },
      /**
       * #action
       */
      zoomOutButton: function zoomOutButton() {
        this.setBpPerPx(self.bpPerPx * 1.4);
      },
      /**
       * #action
       */
      setBpPerPx: function setBpPerPx(newVal) {
        self.bpPerPx = clamp(newVal, self.minBpPerPx, self.maxBpPerPx);
      },
      /**
       * #action
       */
      setModelViewWhenAdjust: function setModelViewWhenAdjust(secondCondition) {
        if (self.lockedFitToWindow && secondCondition) {
          this.setBpPerPx(self.minBpPerPx);
        }
      },
      /**
       * #action
       */
      closeView: function closeView() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getParent(self, 2).removeView(self);
      },
      /**
       * #action
       */
      setDisplayedRegions: function setDisplayedRegions(regions) {
        var previouslyEmpty = self.displayedRegions.length === 0;
        self.displayedRegions = cast(regions);
        if (previouslyEmpty) {
          this.setBpPerPx(self.minBpPerPx);
        } else {
          this.setBpPerPx(self.bpPerPx);
        }
      },
      /**
       * #action
       */
      activateTrackSelector: function activateTrackSelector() {
        if (self.trackSelectorType === 'hierarchical') {
          var session = getSession(self);
          if (isSessionModelWithWidgets(session)) {
            var selector = session.addWidget('HierarchicalTrackSelectorWidget', 'hierarchicalTrackSelector', {
              view: self
            });
            session.showWidget(selector);
            return selector;
          }
        }
        throw new Error("invalid track selector type ".concat(self.trackSelectorType));
      },
      /**
       * #action
       */
      toggleTrack: function toggleTrack(trackId) {
        // if we have any tracks with that configuration, turn them off
        var hiddenCount = this.hideTrack(trackId);
        // if none had that configuration, turn one on
        if (!hiddenCount) {
          this.showTrack(trackId);
        }
      },
      /**
       * #action
       */
      setError: function setError(error) {
        self.error = error;
      },
      /**
       * #action
       */
      showTrack: function showTrack(trackId) {
        var initialSnapshot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var schema = pluginManager.pluggableConfigSchemaType('track');
        var conf = resolveIdentifier(schema, getRoot(self), trackId);
        var trackType = pluginManager.getTrackType(conf.type);
        if (!trackType) {
          throw new Error("unknown track type ".concat(conf.type));
        }
        var viewType = pluginManager.getViewType(self.type);
        var supportedDisplays = viewType.displayTypes.map(function (d) {
          return d.name;
        });
        var displayConf = conf.displays.find(function (d) {
          return supportedDisplays.includes(d.type);
        });
        var track = trackType.stateModel.create(_objectSpread({}, initialSnapshot, {
          type: conf.type,
          configuration: conf,
          displays: [{
            type: displayConf.type,
            configuration: displayConf
          }]
        }));
        self.tracks.push(track);
      },
      /**
       * #action
       */
      addTrackConf: function addTrackConf(configuration) {
        var initialSnapshot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var type = configuration.type;
        var name = readConfObject(configuration, 'name');
        var trackType = pluginManager.getTrackType(type);
        if (!trackType) {
          throw new Error("unknown track type ".concat(configuration.type));
        }
        var viewType = pluginManager.getViewType(self.type);
        var supportedDisplays = viewType.displayTypes.map(function (d) {
          return d.name;
        });
        var displayConf = configuration.displays.find(function (d) {
          return supportedDisplays.includes(d.type);
        });
        self.tracks.push(trackType.stateModel.create(_objectSpread({}, initialSnapshot, {
          name: name,
          type: type,
          configuration: configuration,
          displays: [{
            type: displayConf.type,
            configuration: displayConf
          }]
        })));
      },
      /**
       * #action
       */
      hideTrack: function hideTrack(trackId) {
        var schema = pluginManager.pluggableConfigSchemaType('track');
        var conf = resolveIdentifier(schema, getRoot(self), trackId);
        var t = self.tracks.filter(function (t) {
          return t.configuration === conf;
        });
        transaction(function () {
          return t.forEach(function (t) {
            return self.tracks.remove(t);
          });
        });
        return t.length;
      },
      /**
       * #action
       */
      toggleFitToWindowLock: function toggleFitToWindowLock() {
        // when going unlocked -> locked and circle is cut off, set to the
        // locked minBpPerPx
        self.lockedFitToWindow = !self.lockedFitToWindow;
        this.setModelViewWhenAdjust(self.atMinBpPerPx);
        return self.lockedFitToWindow;
      },
      /**
       * #action
       * creates an svg export and save using FileSaver
       */
      exportSvg: function () {
        var _exportSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var opts,
            html,
            blob,
            _args = arguments;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return renderToSvg(self, opts);
              case 3:
                html = _context.sent;
                blob = new Blob([html], {
                  type: 'image/svg+xml'
                });
                saveAs(blob, opts.filename || 'image.svg');
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function exportSvg() {
          return _exportSvg.apply(this, arguments);
        }
        return exportSvg;
      }()
    };
  }).views(function (self) {
    return {
      /**
       * #method
       * return the view menu items
       */
      menuItems: function menuItems() {
        return [{
          label: 'Return to import form',
          onClick: function onClick() {
            return self.setDisplayedRegions([]);
          },
          icon: FolderOpenIcon
        }, {
          label: 'Export SVG',
          icon: PhotoCameraIcon,
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [ExportSvgDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }, {
          label: 'Open track selector',
          onClick: self.activateTrackSelector,
          icon: TrackSelectorIcon
        }];
      }
    };
  });
}
export default stateModelFactory;